import React from 'react'
import { Skeleton } from '@fs/zion-ui'

export default function SimpleSkeleton() {
  return (
    <>
      <Skeleton.H4 />
      <Skeleton.Paragraph lineCount={2} size="md" />
      <Skeleton.Paragraph lineCount={2} size="md" />
      <Skeleton.Button maxWidth="100%" />
    </>
  )
}
